import { PhoneNumberUtil } from 'google-libphonenumber';
import countries from 'world-countries';

/**
 * Validates a phone number. Pass a full E.164 number on its own, or a national
 * number together with its country prefix.
 * @param phoneNumber Full E.164 number when no prefix is given, otherwise the national number. Can include spaces and dashes.
 * @param prefix Optional country prefix incl. +. E.g +45.
 * @returns A validation message if the phonenumber is invalid, otherwise null.
 */
export function validate(phoneNumber: string, prefix?: string) {
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const number = phoneUtil.parse(prefix ? prefix + phoneNumber : phoneNumber);
    const validNumber = phoneUtil.isValidNumber(number);
    return validNumber ? null : 'Phonenumber is not valid';
  } catch (e) {
    if (e instanceof Error) return e.message;
    return e;
  }
}
/**
 * Splits a full E.164 phone number into dialing prefix and national number.
 * Only call with a number that passed validate().
 */
export function parse(phoneNumber: string) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const number = phoneUtil.parse(phoneNumber);
  return {
    phoneNumberPrefix: `+${number.getCountryCode()}`,
    phoneNumber: phoneUtil.getNationalSignificantNumber(number),
  };
}
/**
 * Function that gets the country prefix from a country code in cca 2 format. I.e. DK, SE, US, TR, NO, AU, GR.
 * @param cca2 country code in cca 2 format.
 * returns The country prefix incl. +. E.g +45
 */
export function getDialingPrefix(cca2: string) {
  const country = countries?.find((c) => c.cca2 === cca2);
  if (!country) throw new Error('Country not found');
  return `${country.idd.root}${
    country.idd.suffixes.length === 1 ? country.idd.suffixes[0] : ''
  }`;
}
